export const providerProfileKeys = {
  base: ["providerProfile"] as const,
  details: (providerId?: string) => [...providerProfileKeys.base, providerId, "details"] as const,
} as const;
